import { CAMPAIGN_NAME_SEPARATOR_REG_EXP, DATE_REG_EXP } from "../regexps";

export const getDeliveryNameFromCampaignName = (campaignName: string) => {
    if (!campaignName) return '';

    let result = campaignName;

    result = result.replaceAll(DATE_REG_EXP, '');
    result = result.replaceAll(CAMPAIGN_NAME_SEPARATOR_REG_EXP, '-');

    return result;
};